/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 16:59:14
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-30 16:35:24
 * @FilePath: /unifyxp-v2-store-portal/src/components/DragContainers/LeftMenuIconDragContainer/index.tsx
 */

import React from 'react';

import css from './css.less';

import {
  MenuOutlined, // DeleteOutlined
} from '@ant-design/icons';
import DeleteButton from 'src/components/Buttons/DeleteButton';

const LeftMenuIconDragContainer = (props) => {
  const {
    dragProps,
    onDelete,
    children,
    dragContainerClassName,
    containerClassName,
    iconClassName,
    disableDelete,
    contentContainerClassName,
    dragDisabled,
    hideDrag,
  } = props;

  return (
    <div className={`${css.container} ${containerClassName || ''}`}>
      {!hideDrag && (
        <div
          className={`${css.dragContainer} ${dragContainerClassName || ''}`}
          {...dragProps}>
          <MenuOutlined
            className={`${css.icon} ${dragDisabled ? css.dragDisabled : ''} ${
              iconClassName || ''
            }`}
            rev
          />
        </div>
      )}

      <div
        className={`${
          onDelete ? css.contentContainerWithDelete : css.contentContainer
        } ${contentContainerClassName || ''}`}>
        {children}
      </div>
      {onDelete && (
        <div className={css.endContainer}>
          <DeleteButton
            disable={disableDelete}
            onClick={onDelete}
            className={`${css.deleteIcon} ${
              disableDelete ? css.deleteCursor : ''
            }`}
          />
        </div>
      )}
    </div>
  );
};
export default LeftMenuIconDragContainer;
